import { ConfigFormData } from '@/models/onboarding';

export function configFormDataFactory(): ConfigFormData {
  return {
    type: null,
    value: undefined,
    customValue: '',
    state: {},
    customValueFocused: false
  };
}
